import React, { useRef } from 'react';
import {
  Cloud,
  CloudRain,
  CloudSnow,
  CloudLightning,
  CloudFog,
  Sun,
  CloudSun,
  Moon,
  CloudMoon,
  ArrowClockwise,
} from '@phosphor-icons/react';
import useSpinAction from '../utils/useSpinAction';

const ICON_WEIGHT = 'bold'; // try: thin, light, regular, bold, fill, duotone

const ICONS = {
  clear:             <Sun size={22} weight={ICON_WEIGHT} className="tw-text-yellow-300" />,
  clearNight:        <Moon size={22} weight={ICON_WEIGHT} className="tw-text-slate-200" />,
  partlyCloudy:      <CloudSun size={22} weight={ICON_WEIGHT} className="tw-text-yellow-200" />,
  partlyCloudyNight: <CloudMoon size={22} weight={ICON_WEIGHT} className="tw-text-slate-200" />,
  cloudy:            <Cloud size={22} weight={ICON_WEIGHT} className="tw-text-white" />,
  rain:              <CloudRain size={22} weight={ICON_WEIGHT} className="tw-text-blue-200" />,
  thunderstorm:      <CloudLightning size={22} weight={ICON_WEIGHT} className="tw-text-yellow-300" />,
  snow:              <CloudSnow size={22} weight={ICON_WEIGHT} className="tw-text-blue-100" />,
  atmosphere:        <CloudFog size={22} weight={ICON_WEIGHT} className="tw-text-gray-300" />,
  empty:             <Cloud size={22} weight="regular" className="tw-text-white tw-opacity-60" />,
};

const resolveIconKey = (weatherData) => {
  if (!weatherData) return 'empty';
  const base = weatherData.iconKey || 'cloudy';
  if (!weatherData.isNight) return base;
  if (base === 'clear') return 'clearNight';
  if (base === 'partlyCloudy') return 'partlyCloudyNight';
  return base;
};

const WeatherWidget = ({ weatherData, onRefresh }) => {
  const isEmpty = !weatherData;
  const iconKey = resolveIconKey(weatherData);
  const cooldownRef = useRef(false);
  const [isSpinning, triggerSpin] = useSpinAction(
    () => (onRefresh ? onRefresh() : Promise.resolve()),
    1000
  );

  const handleRefresh = () => {
    console.log('handleRefresh fired', { cooldown: cooldownRef.current, hasRefresh: !!onRefresh });

    if (cooldownRef.current || !onRefresh) return;
    cooldownRef.current = true;
    triggerSpin();
    setTimeout(() => { cooldownRef.current = false; }, 5000);
  };

return (
  <div
    className="tw-flex tw-items-center tw-gap-4 tw-pl-2 tw-pr-2 tw-py-2 tw-group tw-cursor-pointer"
    onClick={handleRefresh}
    title="Refresh weather"
  >
    <div className="tw-flex tw-flex-col tw-gap-1 tw-bg-black/0 group-hover:tw-bg-black/30 tw-backdrop-blur-50 group-hover:tw-backdrop-blur tw-rounded-xl tw-px-3 tw-py-2 tw-transition-all tw-duration-200">
      <div className="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0 tw-self-start tw-mt-1">
        {ICONS[iconKey]}
        <span className="tw-text-white tw-text-2xl tw-font-bold tw-leading-none">
          {isEmpty ? `--°` : `${Math.round(weatherData.temp)}°`}
        </span>
        <span
          className={`tw-text-white tw-opacity-0 group-hover:tw-opacity-60 tw-transition-opacity tw-duration-200 ${isSpinning ? 'tw-opacity-60 tw-animate-spin' : ''}`}
        >
          <ArrowClockwise size={14} weight="bold" />
        </span>
      </div>

      <span className="tw-text-white tw-text-xs tw-font-medium tw-leading-tight">
        {isEmpty ? '---' : weatherData.city}
      </span>
    </div>
  </div>
);
};

export default WeatherWidget;